<script setup>
/**
 * WhatsappWindowTimer - Badge visual do timer da janela WhatsApp
 *
 * v6.4.7: Refatorado para usar composable compartilhado useWhatsappWindow
 * Exibido entre mensagens e ReplyBox na conversa aberta
 */
import { computed } from 'vue';
import { useWhatsappWindow } from 'dashboard/composables/useWhatsappWindow';

const props = defineProps({
  conversation: {
    type: Object,
    required: true,
  },
  channelType: {
    type: String,
    default: '',
  },
});

const conversationRef = computed(() => props.conversation);
const channelTypeRef = computed(() => props.channelType);

const {
  shouldShow,
  remainingText,
  urgencyIcon,
  timerClasses,
} = useWhatsappWindow({
  conversation: conversationRef,
  channelType: channelTypeRef,
});
</script>

<template>
  <div
    v-if="shouldShow && remainingText"
    class="sticky bottom-0 z-10 flex items-center justify-center gap-1.5 py-1.5 px-4 mx-2 rounded-lg text-sm font-normal transition-all duration-300"
    :class="timerClasses"
  >
    <span class="text-sm">{{ urgencyIcon }}</span>
    <span>{{ remainingText }}</span>
  </div>
</template>
